import { AdminTeams } from '@platform/client';
import { Button } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import { AdminTableContext } from '../../AdminTable';

export const GenerateTeamsCta = ({
  cohortId,
  setTeamsGenerated,
}: {
  cohortId: number;
  setTeamsGenerated: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const queryClient = useQueryClient();
  const proposeTeamsMutator = AdminTeams.useProposeCohortTeams({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: AdminTeams.getGetTeamsQueryKey({
            cohort_id: cohortId,
            page: adminQueryOptionsV2.page,
            limit: adminQueryOptionsV2.limit,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: AdminTeams.getGetFreeAgentsQueryKey({
            cohort_id: cohortId,
            page: adminQueryOptionsV2.page,
            limit: adminQueryOptionsV2.limit,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: AdminTeams.getGetTeamsCountsQueryKey({
            cohort_id: cohortId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: AdminTeams.getGetTeamIdsQueryKey({ cohort_id: cohortId }),
        });
        setTeamsGenerated(true);
      },
    },
  });
  return (
    <div className='flex flex-col items-center mt-20 gap-6 text-center'>
      <p className='text-display-sm'>No teams exists, you can generate team suggestions below</p>
      <Button
        variant='primary'
        size='md'
        additionalClassnames='w-fit'
        onPress={() => proposeTeamsMutator.mutate({ data: { cohort_id: cohortId } })}
        isDisabled={proposeTeamsMutator.isPending || proposeTeamsMutator.isError}
      >
        Generate Teams
      </Button>
      {proposeTeamsMutator.isError && <p className='text-error-500'>Error generating teams</p>}
    </div>
  );
};
